module["exports"] = [
  "Pvt Ltd",
  "Group",
  "Ltd",
  "Limited"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nep/company/suffix.js
// module id = 1884
// module chunks = 0